import React from "react";

import LoadingIcon from "../../loading-icon/loading-icon";
import { Box } from "../../theme/containers";
import { PcaSubHeading } from "../../theme/typography";

const ReloadingJourney = () => (
    <Box textAlign="center" className="u-my-17">
        {/* @ts-ignore */}
        <LoadingIcon size="medium" />
        <PcaSubHeading>
            One moment, we&apos;re getting things ready for you
        </PcaSubHeading>
    </Box>
);

export default ReloadingJourney;
